import $ from "jquery";
const nextPrevObj = {
  variable:{
    url: window.location.href,
},
  methods: {
    init: function () {

            $('.previous-next__wrapper--next').on('click', function(e){
              var obj = nextPrevObj.methods.dataLayerObj(e);
              createDataLayer('List_Scroll_Next', obj);
            });
            $('.previous-next__wrapper--prev').on('click', function(e){
              var obj = nextPrevObj.methods.dataLayerObj(e);
              createDataLayer('List_Scroll_Previous', obj);
            });
    },

    dataLayerObj: function (e) {
        var obj = {
            'articleName' : "",
            'blogCategory' : "",
            'blogPageCategory' : "",
            'buttonText' : e ? e.currentTarget.innerText.replace(/\n/g, '').trim() : "",
            'pageSection' : "",
            'gclid' : "gclid",
            'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? nextPrevObj.variable.url.includes("blog") ? "Blogs" : nextPrevObj.variable.url.substring(nextPrevObj.variable.url.indexOf(".com/"), nextPrevObj.variable.url.lastIndexOf('/')  === ".com") && !nextPrevObj.variable.url.substring(nextPrevObj.variable.url.indexOf(".com/"), nextPrevObj.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
            'planOption' : "",
            'productCategory' : "",
            'productName' : "",
            'question' : "",
            'source' : "",
            'searchTerm' : "",
            'videoTitle' : "",
            'bannerName' : "",

        };
        return obj;
    }
  },
};

$(() => {
  if ($(".previous-next").length > 0) {
    nextPrevObj.methods.init();
  }
});
